import styled from 'styled-components'

const LifecycleInterventionInputStyled = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 27px;
  width: 100%;
  

  .default-label {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    margin-top: 4px;
    font-size: 13px;
    font-style: italic;
    color: #444f56;
  }

  .date-field-wrapper {
    .ant-picker {
      width: 100%;
    }
  }

  .notes-field-wrapper {
    width: 100%;
    margin-top: -26px;
  }

  .lifecycle-intervention-comment-label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: rgba(0, 0, 0, .85);
  }

  .lifecycle-intervention-comment > span.ant-input-textarea-suffix {
    top: 4px;
    bottom: unset;
  }

  .remaining-life-label {
    margin-top: 12px;
    color: rgba(0, 0, 0, .85);
  }
`

export default LifecycleInterventionInputStyled
